import React, { useEffect, useState } from 'react';
import { array, bool, number, object } from 'prop-types';

import { connect } from 'react-redux';

import { find, get, isEmpty } from 'lodash';

import { useFormik } from 'formik';
import * as Yup from 'yup';

import FormControl from '@material-ui/core/FormControl';

import AutoComplete from '../../../components/FormFields/Autocomplete';

import * as CoreActions from '../../../actions/coreActions';
import * as WizardActions from '../../../actions/wizardActions';

import classes from './WizardStep.module.css';

const ValidationSchema = Yup.object().shape({
    profile: Yup.string().required()
});

const ProfileStep = ({
    companyInfo,
    fetchProfileObjects,
    resetFromStepTwo,
    setProgressBarLoading,
    setTargetProfile,
    setValidateForm,
    targetProfile,
    targetProfiles,
    validateForm,
    ...props
}) => {
    const [transformedProfiles, setTransformedProfiles] = useState([]);

    useEffect(() => {
        if (validateForm) {
            formik.handleSubmit();

            setValidateForm(false);
        }
    }, [validateForm]);

    useEffect(() => {
        convertProfiles();
    }, [targetProfiles]);

    const formik = useFormik({
        initialValues: {
            profile: targetProfile
        },
        validationSchema:   ValidationSchema,
        enableReinitialize: true,
        onSubmit:           async (values, { setSubmitting }) => {
            const {
                activeStep,
                setActiveStep,
                setProfileName
            } = props;

            setProfileName(targetProfile.name);
            setActiveStep(activeStep + 1);
        }
    });

    const convertProfiles = () => {
        const profiles = [
            {
                items:     [...targetProfiles],
                name:      'Profiles',
                itemProps: {
                    type: 'profiles'
                }
            }
        ];

        setTransformedProfiles(profiles);
    };

    const handleProfileSelect = async event => {
        resetFromStepTwo();
        setProgressBarLoading(true);

        const { value } = event.target;

        if (isEmpty(value)) {
            formik.handleChange(event);
            setProgressBarLoading(false);

            return;
        }

        const targetProfile = find(targetProfiles, profile => profile.id === value.id);
        const profileId = get(value, 'id');

        setTargetProfile(targetProfile);

        formik.handleChange(event);

        let isFetched = await fetchProfileObjects(profileId);

        if (isFetched) {
            setProgressBarLoading(false);
        }
    };

    return (
        <div className={classes.wizardForm}>
            <div className={classes.formColumn}>
                <div className={classes.labelColumn}>
                    <div className={classes.labelHeader}>
                        <img src="/assets/images/profilesIconColor.svg" alt="Profile Icon" />
                        <span>Target Profile</span>
                    </div>
                    <div className={classes.labelContent}>
                        <p>
                            The Profile selected will be mapped to an Equipment Type and be used to create Equipment and Sensors.
                        </p>
                    </div>
                </div>
                <div className={classes.inputColumn}>
                    <div className={classes.inputs}>
                        <FormControl className={classes.inputWrapper}>
                            <AutoComplete
                                grouped
                                label="Profile"
                                name="profile"
                                onBlur={formik.handleBlur}
                                onChange={handleProfileSelect}
                                options={transformedProfiles}
                                placeholder="Profile"
                                value={formik.values.profile}
                                error={Boolean(formik.errors.profile) && Boolean(formik.touched.profile)}
                                helperText={Boolean(formik.touched.profile) && formik.errors.profile}
                            />
                        </FormControl>
                    </div>
                </div>
            </div>
        </div>
    );
};

ProfileStep.defaultProps = {
    activeStep:     1,
    companyInfo:    {},
    targetProfiles: [],
    targetProfile:  {},
    validateForm:   false
};

ProfileStep.propTypes = {
    activeStep:     number,
    companyInfo:    object,
    targetProfiles: array,
    targetProfile:  object,
    validateForm:   bool
};

const mapStateToProps = state => {
    return {
        activeStep:     state.wizard.activeStep,
        companyInfo:    state.companyInfo,
        targetProfiles: state.wizard.targetProfiles,
        targetProfile:  state.wizard.targetProfile,
        validateForm:   state.wizard.validateForm
    };
};

const mapDispatchToProps = {
    ...CoreActions,
    ...WizardActions
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileStep);
